import Swal from 'sweetalert2'

/*
alert 관련 메시지 이벤트 저장 후 사용
 */

export default {
    methods: {
        createAlert(params){
            Swal.fire({
                title: !params.title ? '' : params.title,
                html: !params.content ? '' : params.content,
                confirmButtonText: !params.btnText ? '확인' : params.btnText,
                customClass: !params.customClass ? 'alert-common' : params.customClass,
                willClose: () => {
                    if(params.back){
                        window.history.back();
                    }else if(params.hide) {
                        params.hide();
                    }
                }
            })
        },
        createConfirm(params){
            Swal.fire({
                title: !params.title ? '' : params.title,
                html: !params.content ? '' : params.content,
                confirmButtonText: !params.confirmText ? '확인' : params.confirmText,
                cancelButtonText: !params.cancelText ?'취소' : params.cancelText,
                showCancelButton: true,
                customClass: !params.customClass ? 'alert-common confirm ' : params.customClass,
                // showCloseButton: true,
                // allowOutsideClick: false,

            }).then((result) => {
                if (result.value) {
                    if(params.confirm)
                        params.confirm();
                } else {
                    if(params.cancel)
                        params.cancel();
                }
            })
        },


        errorAlert(params){
            Swal.fire({
                title: params,
                html: '',
                confirmButtonText: '확인',
                customClass: !params.customClass ? 'alert-common' : params.customClass,
                willClose: () => {

                }
            })
        },

        backErrorAlert(params){
            Swal.fire({
                title: '',
                html: params,
                confirmButtonText: '확인',
                willClose: () => {
                    window.history.back();
                }
            })
        },

        modalSaveAlert(params){

            Swal.fire({
                title: '',
                html: '저장완료.',
                confirmButtonText: '확인',
                willClose: () => {
                    params.element.modalHide();
                }
            })
        },

        historyBackAlert(params){
            Swal.fire({
                title: '',
                html: params.content,
                confirmButtonText: params.btnText,
                willClose: () => {
                    window.history.back();
                }
            })
        },
    }
}
